import React, { useMemo, useState } from "react";
import "./FlightSearchResult.css";
import { useLocation } from "react-router-dom";
import FlightSearch from "../FlightSearch.jsx";
import FlightCard from "./FlightCard.jsx";


const formatDate = date =>
  new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });

export default function FlightSearchResult() {
  const location = useLocation();
  const results = location?.state?.results;
  const searchData = location.state?.searchData

  console.log("before .....",results);

  // API RESULT ARRAY
  const cardData =
    results?.data?.responseData?.Response?.Results?.["0"] || results?.responseData?.Response?.Results?.["0"] || [];
    const origins = results?.data?.responseData?.Response?.Origin
    const destinations = results?.data?.responseData?.Response?.Destination
    console.log("the total card data is ",cardData)
    const segment = cardData[0]?.Segments?.[0]?.[0]
    console.log(" the segment is :",segment)
const traceId = results?.data?.responseData?.Response?.TraceId || results?.responseData?.Response?.TraceId
  /* ---------------- FILTER STATES ---------------- */
const [filters, setFilters] = useState({
  stops: [],                 // ["direct","1stop"]
  price: [0, 20000],         // min, max
  depTime: [],               // morning / afternoon / evening / night
  arrTime: [],
  duration: 1000,            // max minutes
  refundable: null,          // true | false | null
  fareTypes: [],             // Saver, Corporate, Flexi...
  airlines: []               // 6E, AI, SG...
});


  const [expandedCard, setExpandedCard] = useState(null);
  const getTimeSlot = (dateStr) => {
  const hour = new Date(dateStr).getHours();
  if (hour < 6) return "night";
  if (hour < 12) return "morning";
  if (hour < 18) return "afternoon";
  return "evening";
};


  /* ---------------- FILTER LOGIC ---------------- */

  console.log("before filtering: ",cardData)
const filteredData = useMemo(() => {
  return cardData.filter((item) => {
    const seg = item.Segments?.[0]?.[0];
    if (!seg) return false;

    const stops = item?.Segments?.[0]?.length > 1 ?  "1stop" : "direct";
    const depSlot = getTimeSlot(seg.Origin.DepTime);
    const arrSlot = getTimeSlot(seg.Destination.ArrTime);
    const duration = seg.Duration;
    const price = item.Fare.OfferedFare;

    // Stops
    if (filters.stops.length && !filters.stops.includes(stops)) return false;

    // Price
    if (price < filters.price[0] || price > filters.price[1]) return false;

    // Departure Time
    if (filters.depTime.length && !filters.depTime.includes(depSlot)) return false;

    // Arrival Time
    if (filters.arrTime.length && !filters.arrTime.includes(arrSlot)) return false;

    // Duration
    if (duration > filters.duration) return false;

    // Fare type (Refundable)
    if (filters.refundable !== null && item.IsRefundable !== filters.refundable)
      return false;

    // Fare Family
    if (
      filters.fareTypes.length &&
      !filters.fareTypes.includes(item.ResultFareType)
    )
      return false;

    // Airlines
    if (
      filters.airlines.length &&
      !filters.airlines.includes(seg.Airline.AirlineCode)
    )
      return false;

    return true;
  });
}, [cardData, filters]);

console.log("after filtering: ",filteredData);


  const toggleExpand = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  return (
    <>
    <FlightSearch initialData={searchData}/>
        <div className="fsr-page">

      {/* ================= LEFT FILTER PANEL ================= */}
<aside className="fsr-filter">
  <span style={{display:"flex",justifyContent:"space-between"}}>
    <span style={{fontWeight:"600",fontSize:"1.3rem",textDecoration:"underline",color:"gold"}}>Filters</span>
    <button
      className="reset-btn"
      onClick={() =>
        setFilters({
          stops: [],
          price: [0, 20000],
          depTime: [],
          arrTime: [],
          duration: 1000,
          refundable: null,
          fareTypes: [],
          airlines: []
        })
      }
    >
      Reset All
    </button>
  </span>

  {/* STOPS */}
  <div className="filter-block">
    <h4>Number of Stops</h4>
    <label>
      <input
        type="checkbox"
        onChange={(e) =>
          setFilters(f => ({
            ...f,
            stops: e.target.checked
              ? [...f.stops, "direct"]
              : f.stops.filter(s => s !== "direct")
          }))
        }
      />
      Direct
    </label>
    <label>
      <input
        type="checkbox"
        onChange={(e) =>
          setFilters(f => ({
            ...f,
            stops: e.target.checked
              ? [...f.stops, "1stop"]
              : f.stops.filter(s => s !== "1stop")
          }))
        }
      />
      1 Stop
    </label>
  </div>

  {/* PRICE */}
  <div className="filter-block">
    <h4>Price (₹)</h4>
    <input
      type="range"
      min="0"
      max="20000"
      step="500"
      value={filters.price[1]}
      onChange={(e) =>
        setFilters(f => ({ ...f, price: [0, +e.target.value] }))
      }
    />
    <span>Up to ₹{filters.price[1]}</span>
  </div>

  {/* DEPARTURE TIME */}
  <div className="filter-block">
    <h4>Departure Time</h4>
    {["morning","afternoon","evening","night"].map(t => (
      <label key={t}>
        <input
          type="checkbox"
          onChange={(e) =>
            setFilters(f => ({
              ...f,
              depTime: e.target.checked
                ? [...f.depTime, t]
                : f.depTime.filter(x => x !== t)
            }))
          }
        />
        {t}
      </label>
    ))}
  </div>

  {/* ARRIVAL TIME */}
  <div className="filter-block">
    <h4>Arrival Time</h4>
    {["morning","afternoon","evening","night"].map(t => (
      <label key={t}>
        <input
          type="checkbox"
          onChange={(e) =>
            setFilters(f => ({
              ...f,
              arrTime: e.target.checked
                ? [...f.arrTime, t]
                : f.arrTime.filter(x => x !== t)
            }))
          }
        />
        {t}
      </label>
    ))}
  </div>

  {/* DURATION */}
  <div className="filter-block">
    <h4>Fly Duration</h4>
    <input
      type="range"
      min="60"
      max="1000"
      step="30"
      value={filters.duration}
      onChange={(e) =>
        setFilters(f => ({ ...f, duration: +e.target.value }))
      }
    />
    <span>Up to {filters.duration} mins</span>
  </div>

  {/* FARE TYPE */}
  <div className="filter-block">
    <h4>Fare Type</h4>
    <label>
      <input type="radio" name="fare"
        onChange={() => setFilters(f => ({ ...f, refundable: true }))} />
      Refundable
    </label>
    <label>
      <input type="radio" name="fare"
        onChange={() => setFilters(f => ({ ...f, refundable: false }))} />
      Non-Refundable
    </label>
  </div>

  {/* AIRLINES */}
  <div className="filter-block">
    <h4>Airlines</h4>
    {["6E","AI","QP","SG","IX"].map(code => (
      <label key={code}>
        <input
          type="checkbox"
          onChange={(e) =>
            setFilters(f => ({
              ...f,
              airlines: e.target.checked
                ? [...f.airlines, code]
                : f.airlines.filter(a => a !== code)
            }))
          }
        />
        {code}
      </label>
    ))}
  </div>
</aside>


      {/* ================= RIGHT RESULTS ================= */}
        <main className="fsr-results">
          <div style={{color:"white",fontWeight:"600"}}>{filteredData?.length || cardData?.length} Flights found - {origins} to {destinations} | {formatDate(segment?.Origin?.DepTime)}</div>
{(filteredData?.length > 0 ? filteredData : cardData)?.map((item, index) => (
  <FlightCard
    key={item?.ResultIndex || index}
    item={item}
    index={index}
    expandedCard={expandedCard}
    toggleExpand={toggleExpand}
    traceId={traceId}
  />
))}


          {filteredData.length === 0 && (
            <p className="no-result">No flights match your filters</p>
          )}
        </main>
    </div>
    </>

  );
}
